



















































































































import { Component, Vue, Mixins, Prop } from "vue-property-decorator";
import Loading from "@/mixins/loading";
import tablePagination from "@/mixins/tablePagination";
// api
import { rechargeList } from "@/api/recharge";
import { ChargeList } from "@/types/api/recharge";
import { selectAllLabel } from "@/api/discount";
import copy from "@/utils/deepCopy";
import { saveUserProxy } from "@/api/userProxy";
import filterPrice from "@/utils/inputPrice";

@Component
export default class Table extends Mixins(Loading, tablePagination) {
  @Prop() fromDate!: string;
  @Prop() shopName!: string;
  @Prop() phone!: string;
  @Prop() userName!: string;
  @Prop() status!: number;

  private tableData: Array<any> = [];
  imgUrl: string = "";
  dialogTitle: string = "";
  dialogVisibleUserProxy: boolean = false;
  dialogVisibleImg: boolean = false;
  userProxyForm = {
    id: Number,
    agentName: String,
    agentDesc: String,
  };
  mounted() {
    this.getData();
  }

  /**
   * methods
   */
  getData(): void {
    this.showLoading();
    rechargeList({
      fromDate: this.fromDate && this.fromDate.toString().split(",")[0],
      toDate: this.fromDate && this.fromDate.toString().split(",")[1],
      phone: this.phone,
      userName: this.userName,
      pageNum: this.currentPage,
      pageSize: this.pageSize,
      status: this.status,
    }).then((res: any) => {
      res.data.list.forEach((e: any) => {
        e.totalAmound = filterPrice(
          (e.giveAmount * 100 + e.payAmount * 100) / 100
        );
      });
      this.tableData = res.data.list;
      this.total = res.data.total;
      this.hideLoading();
    });
  }
  // 预览图片
  previewPic(url: string, title: string) {
    this.dialogTitle = title;
    this.imgUrl = url;
    this.dialogVisibleImg = true;
  }
}
